import styles from './Footer.module.scss';
import { ItemType } from '../App';
import { Link, useOutletContext } from 'react-router';
import { useAppSelector } from '../Redux/hooks';


const Footer = () => {

    const { items } = useOutletContext<{ items: ItemType[] }>();
    const isLogined = useAppSelector((state) => state.authorization.value);

    const selectedItems = items.filter(el => el.isSelected);
    const itemsLoading = items.find(el => el.isLoading);

    const startPriceSelected = selectedItems.reduce((sum, item) => sum + item.startPrice, 0);
    const finalPriceSelected = selectedItems.reduce((sum, item) => sum + item.finalPrice, 0);


    return (
        <footer className={styles.Footer}>

            {isLogined
                ? <Link to="/main"><img src={"assets/img/icons/home.svg"} alt="home" /></Link>
                : <Link to="/info"><img src={"assets/img/icons/info.svg"} alt="info" /></Link>
            }

            {itemsLoading
                ? <p>Подсчёт суммы...</p>
                : <>

                    <p>
                        <>Общая сумма: </>
                        {/* 
                        {items.length === selectedItems.length
                            ? <>Общая сумма: </>
                            : <>Из {items.length} предмет{[1, 21, 31, 41, 51, 61, 71, 81, 91].includes(items.length % 100) ? "а" : "ов"} выбрано: <b>{selectedItems.length}</b> на сумму&nbsp;</>
                        } */}
                        {startPriceSelected === finalPriceSelected
                            ? <b>{(startPriceSelected).toLocaleString('ru')} руб.</b>
                            : <s>{(startPriceSelected).toLocaleString('ru')} руб.</s>
                        }
                    </p>

                    {startPriceSelected !== finalPriceSelected &&
                        <p>
                            Сумма со скидкой: <b>{finalPriceSelected.toLocaleString('ru')} руб.</b> &nbsp;
                            {!!Math.round((1 - finalPriceSelected / startPriceSelected) * 100) &&
                                <>Общая скидка: <b> {Math.round((1 - finalPriceSelected / startPriceSelected) * 100)} %</b></>
                            }

                        </p>
                    }
                </>
            }
        </footer >
    )
}

export default Footer;


